import React from 'react'
import Logo from "../../../../assets/images/LogoNew.svg";
import { ApplicantHeaderActions } from '../../../../components/ApplicationInvite';
import { FORM_AUTOFILL_PROPS } from '../../../../components/InputField/autofillProps';
import LogoutWithReason from '../../../../components/LogoutWithReason/LogoutWithReason';
import { Form } from 'react-bootstrap';
import { useTranslation } from '../../../../store/context/TranslationContext';
import { FaSpinner } from 'react-icons/fa';

export const FORM_CONTAINER_TYPE = {
    EDD: "EDD"
}
const FormContainer = ({
    asLabel,
    editMode,
    form_id,
    title = '',
    children,
    isLoading,
    formContainerType,
    applicationForm,
    applicationFormId,
    formData,
    onApplicationFormUpdated,
}) => {
    const { t } = useTranslation();
    const isEddApplication = formContainerType === FORM_CONTAINER_TYPE.EDD
        && applicationForm?.eDDApplication === true;

    return (
        <div className={!asLabel && !editMode ? 'form-content-container xl' : ""}>
            <div className='form-content-header'>
                {!asLabel && <img
                    src={Logo}
                    alt={t("fv-bank")}
                    className="logo logo-dark form-content-logo"
                />}

                <div className='d-flex align-items-center gap-3'>
                    <ApplicantHeaderActions
                        applicationForm={applicationForm}
                        formData={formData}
                        formId={applicationFormId || applicationForm?._id || form_id}
                        formType={applicationForm?.formType}
                        onApplicationFormUpdated={onApplicationFormUpdated}
                        invitePersistence={isEddApplication ? "edd-request" : "application-form"}
                        disabled={asLabel || editMode}
                        logoutComponent={(
                            <LogoutWithReason
                                form_id={form_id}
                                withoutReason={isEddApplication}
                            />
                        )}
                    />
                </div>
            </div>

            {
                isLoading ? (
                    <div className=" form-content-body  d-flex justify-content-center align-items-center flex-1">
                        <FaSpinner size={20} className="spinner" />
                    </div>
                ) : (
                    <Form className={asLabel ? "" : 'form-content-body d-flex flex-column'} noValidate {...FORM_AUTOFILL_PROPS}>
                        <div className='form-content-body-header'>
                            <div className="heading">{t(title)}</div>
                        </div>

                        {children}
                    </Form>
                )
            }
        </div>
    )
}

export default FormContainer;
